







import { Vue, Prop, Component } from "vue-property-decorator";

import { MenuItem } from "@/types";

@Component({})
export default class MenuItemLink extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  item!: MenuItem;

  @Prop({
    type: Boolean,
    default: false,
  })
  isActive!: boolean;

  get classes() {
    return {
      "menu-item": true,
      "menu-item--active": this.isActive,
    };
  }

  onClick(item: MenuItem) {
    console.log("LINK ACTION", item.action);
    if (item.action) this.$emit(item.action, item);
  }
}
